module.exports = __webpack_public_path__ + "assets/img/companyImg.64a26c23.png";